import styled from 'styled-components';
import { Box } from '../CommonComponents/OPL/Box/Box';

export const TilesGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(238px, 1fr))',
  gap: 16,

  [`@media (min-width: 1000px)`]: {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
});
